import { render } from "./OrderStatusesSettingsPage.vue?vue&type=template&id=49aaa43a"
import script from "./OrderStatusesSettingsPage.vue?vue&type=script&lang=js"
export * from "./OrderStatusesSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__